<template>
  <div
    class="wrn-tooltip"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <BaseIcon
      class="icon"
      :icon="icon"
      :width="iconWidth"
      :height="iconHeight"
      :colors="color"
    />
    <BaseText
      v-show="hovered"
      size="sm"
      :class="['text-p-5', 'content', `show-on-${side}`]"
      :color="NebraskaColors.textNegative"
    >
      {{ text }}
      <slot v-if="!text" />
    </BaseText>
    <slot name="content" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { BaseText, BaseIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: { BaseIcon, BaseText }
})
export default class Tooltip extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: String })
  public text!: string;

  @Prop({ type: String, default: NebraskaColors.progressBackground })
  public color!: string;

  @Prop({ type: String, default: 'ic_help_circle', required: false })
  public icon?: string;

  @Prop({ type: String, default: '14', required: false })
  public iconWidth?: string;

  @Prop({ type: String, default: '14', required: false })
  public iconHeight?: string;

  @Prop({ type: String, default: 'top' })
  public side?: string;

  private hovered = false;

  @Watch('hovered')
  @Emit()
  private change() {
    return this.hovered;
  }
}
</script>

<style lang="less" scoped>
.wrn-tooltip {
  display: inline-block;
  line-height: 14px; // same as icon height
  position: relative;
  vertical-align: 1px;
}
.icon {
  cursor: pointer;
}
.content {
  background-color: @base-select;
  border-radius: 5px;
  position: absolute;
  bottom: ~'calc(100% + 8px)';
  left: 50%;
  text-align: center;
  transform: translate(-50%, 0%);
  width: 250px;
  padding: @size-spacing-x400;

  &.show-on-left {
    transform: translate(-110%, 50%);
    bottom: ~'calc(50% + 8px)';
    &::after {
      top: 50%;
      left: 100%;
      transform: rotate(-90deg) translateY(5px);
    }
  }

  &.show-on-bottom {
    transform: translate(-50%, 110%);
    bottom: calc(100% - 8px);

    &::after {
      top: auto;
      bottom: 100%;
      left: 50%;
      transform: rotate(-180deg) translateY(-1px);
    }
  }

  /*
  este seletor é uma alternativa pra sobrepor as definições
  de cores em nossas classes de texto, permitindo que trocas de
  tamanho da fonte não mudem a cor do texto dentro do tooltip.
  furutamente, com mudanças no CSS, podemos remover essa regra
  */
  * {
    color: currentColor;
  }

  &::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparent;
    border-top-color: @base-select;
    border-width: 6px;
    margin-left: -6px;
  }
}
</style>
